import React, { useCallback, useEffect, useState } from "react";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation } from "swiper/modules";
import config from "../../../util/config";
import { Mentor } from "../../mentors/Mentors";
import { Autoplay } from "swiper/modules";
import { convertToKebabCase } from "../../../util/commonUtils";

const mentors = [
  {
    imageUrl: "/images/mentors/sm01.png",
    name: "Ravi",
    role: "Admission Mentor",
  },
  {
    imageUrl: "/images/mentors/sm02.png",
    name: "K. Madhan",
    role: "Loan Mentor",
  },
  {
    imageUrl: "/images/mentors/sm03.png",
    name: "Radha",
    role: "Student Mentor",
  },
  {
    imageUrl: "/images/mentors/sm04.png",
    name: "Ramya.V",
    role: "Scholarship Mentor",
  },
  {
    imageUrl: "/images/mentors/sm02.png",
    name: "K. Madhan",
    role: "Loan Mentor",
  },
  {
    imageUrl: "/images/mentors/sm03.png",
    name: "Radha",
    role: "Student Mentor",
  },
  {
    imageUrl: "/images/mentors/sm04.png",
    name: "Ramya.V",
    role: "Scholarship Mentor",
  },
];
interface MentorCardProps {
  mentor: Mentor;
}

const SimilarMentors: React.FC<MentorCardProps> = ({ mentor }) => {
  const [similarmentor, setsimilarMentors] = useState<Mentor | null>();
  const [prepareSimilarmentors, setprepareSimilarmentors] = useState<any>();
  const [swiperRef, setSwiperRef] = useState<SwiperClass>();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [totalSlides, setTotalSlides] = useState(0);
  const [isPrevHovered, setIsPrevHovered] = useState(false);
  const [navBtnDisabled, setNavBtnDisabled] = useState({
    prev: true,
    next: false,
  });

  useEffect(() => {
    const fetchMentorDetails = async () => {
      try {
        const response = await fetch(
          config.apiUrl + `/api/auth/mentors/mentorList`
        );
        const data = await response.json();
        setsimilarMentors(data.data);
        prepareSimilarMentors(data.data);
        if (swiperRef && swiperRef.slides) {
          setTotalSlides(swiperRef.slides.length);
        }
      } catch (error) {
        console.error("Error fetching mentor details:", error);
      }
    };

    fetchMentorDetails();
  }, [swiperRef]);
  const prepareSimilarMentors = (data: any) => {
    const filterData = data.filter(
      (item: any) => item.role === mentor?.role && item.id !== mentor?.id
    );

    setprepareSimilarmentors(filterData);
  };

  const handleSlideChange = () => {
    if (swiperRef) {
      setCurrentSlide(swiperRef.realIndex || 0);
      setNavBtnDisabled({
        prev: swiperRef.isBeginning,
        next: swiperRef.isEnd,
      });
    }
  };

  const handlePrevious = useCallback(() => {
    swiperRef?.slidePrev();
  }, [swiperRef]);

  const handleNext = useCallback(() => {
    swiperRef?.slideNext();
  }, [swiperRef]);
  const progressBarElement = (
    <div className="flex items-center gap-4">
      <span>{currentSlide + 1}</span>
      <div className="w-24 h-1 bg-[#D9D9D9]">
        <div
          className="h-full bg-[#173CBA]"
          style={{
            width: totalSlides
              ? ((currentSlide + 1) / totalSlides) * 100 + "%"
              : "0%",
          }}
        ></div>
      </div>
      <span>{totalSlides}</span>
    </div>
  );

  const prevButton = (
    <button
      className={`${navBtnDisabled.prev ? "" : ""} p-2.5`}
      onClick={handlePrevious}
      onMouseEnter={() => setIsPrevHovered(true)}
      onMouseLeave={() => setIsPrevHovered(false)}
    >
      <LeftArrow />
    </button>
  );

  const nextButton = (
    <button
      className={`${navBtnDisabled.next ? "" : ""} p-2.5`}
      onClick={handleNext}
    >
      <RightArrow isPrevHovered={isPrevHovered} />
    </button>
  );

  return (
    <>
      {prepareSimilarmentors?.length > 0 ? (
        <div className="bg-[#EEF2FF] py-10">
          <div className="container mx-auto">
            <h2 className="text-2xl font-semibold text-[#173CBA] mb-6">
              Similar Mentor
            </h2>

            <Swiper
              onSwiper={setSwiperRef}
              onSlideChange={handleSlideChange}
              spaceBetween={10}
              modules={[Autoplay]}
              loop={true}
              autoplay={{
                delay: 1500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                },
              }}
            >
              {prepareSimilarmentors?.map((mentor: any, index: any) => (
                <SwiperSlide key={index}>
                  <div className="bg-white rounded-lg overflow-hidden shadow-md">
                    <a
                      href={`/mentor/${convertToKebabCase(mentor.name)}-${
                        mentor.id
                      }`}
                    >
                      <img
                        src={mentor.imageUrl}
                        alt={mentor.name}
                        className="w-full h-52 object-cover"
                      />
                    </a>
                    <div className="bg-[#173CBA] text-white text-center p-4 relative">
                      <h3 className="text-lg font-semibold">{mentor.name}</h3>
                      <p className="text-sm">{mentor.role}</p>

                      <div className="absolute bottom-3 right-3">
                        <span className="  p-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="26"
                            height="35"
                            viewBox="0 0 26 35"
                            fill="none"
                          >
                            <path
                              d="M7.25599 35.0001L5.01627 30.3636L0 31.5244L6.35751 18.2527L13.6135 21.7283L7.25599 35.0001Z"
                              fill="#E5373A"
                            />
                            <path
                              d="M13.1681 21.5151L6.98151 34.4313L7.25597 35L13.6135 21.7283L13.1681 21.5151Z"
                              fill="#E6E7E8"
                            />
                            <path
                              d="M18.0412 35.0001L20.2809 30.3636L25.2972 31.5244L18.9396 18.2527L11.6845 21.7283L18.0412 35.0001Z"
                              fill="#E5373A"
                            />
                            <path
                              d="M12.129 21.5151L18.3165 34.4313L18.0412 35L11.6845 21.7283L12.129 21.5151Z"
                              fill="#E6E7E8"
                            />
                            <path
                              d="M19.3297 19.0676C17.6225 20.7869 15.2577 21.8537 12.6485 21.8537C11.2995 21.8537 10.017 21.5689 8.85613 21.0562C7.77122 20.5772 6.79334 19.8988 5.96737 19.0685L4.9541 21.1831C5.54532 21.2271 6.25478 21.1287 6.65956 21.3988C6.98063 21.6129 7.15843 22.0997 7.35435 22.558C7.53387 22.9791 7.72893 23.3753 8.0595 23.5134C8.74047 23.7956 9.8038 22.8626 10.5443 23.0094C11.1675 23.1328 11.7207 24.1063 12.3525 24.3618L12.6494 23.743L12.9463 24.3618C13.5781 24.1063 14.1313 23.1328 14.7545 23.0094C15.495 22.8626 16.5583 23.7965 17.2393 23.5134C17.9324 23.226 18.023 21.8114 18.6392 21.3988C19.044 21.1278 19.7535 21.2262 20.3447 21.1831L19.3297 19.0676Z"
                              fill="#D1D3D4"
                            />
                            <path
                              d="M12.6486 21.6522C17.9854 21.6522 22.3117 17.3259 22.3117 11.9891C22.3117 6.65226 17.9854 2.32593 12.6486 2.32593C7.31175 2.32593 2.98541 6.65226 2.98541 11.9891C2.98541 17.3259 7.31175 21.6522 12.6486 21.6522Z"
                              fill="#F9D511"
                            />
                            <path
                              d="M23.2232 14.0934C23.3656 13.3753 24.6378 12.7495 24.6378 11.9892C24.6378 11.2288 23.3656 10.603 23.2232 9.88496C23.0764 9.14443 24.0103 8.0811 23.7272 7.40012C23.59 7.06697 23.193 6.87364 22.7718 6.69498C22.3143 6.49992 21.8284 6.32126 21.6127 6.0002C21.1966 5.37877 21.6515 4.03753 21.125 3.51105C20.9058 3.29182 20.5467 3.24262 20.1566 3.23054C19.6086 3.21242 19.0001 3.26679 18.6367 3.02426C18.4296 2.88531 18.282 2.63415 18.1508 2.34933C17.891 1.78832 17.6968 1.10044 17.2368 0.909696C16.5558 0.627465 15.4925 1.56046 14.752 1.41374C14.033 1.27133 13.4073 0 12.6477 0C11.8874 0 11.2616 1.27219 10.5435 1.41374C10.4633 1.43014 10.3787 1.43273 10.2915 1.42582C9.57688 1.37145 8.66632 0.657674 8.0587 0.909696C7.36564 1.1971 7.27502 2.61171 6.65877 3.02426C6.03821 3.44027 4.69697 2.98542 4.17049 3.51105C3.644 4.03753 4.09885 5.37877 3.68284 6.0002C3.27029 6.61644 1.85568 6.7062 1.56827 7.39926C1.31712 8.00688 2.03003 8.91743 2.0844 9.63207C2.09217 9.72011 2.08872 9.80469 2.07232 9.88496C1.92991 10.6039 0.657715 11.2296 0.657715 11.9892C0.657715 12.7487 1.92991 13.3753 2.07232 14.0934C2.21904 14.8339 1.28518 15.8981 1.56827 16.5791C1.75902 17.0391 2.4469 17.2342 3.00791 17.4922C3.29186 17.6243 3.54388 17.7727 3.68198 17.979C3.92451 18.3415 3.87013 18.95 3.88826 19.4989C3.9012 19.889 3.9504 20.2489 4.16962 20.4673C4.69525 20.9938 6.03648 20.5389 6.65791 20.9549C6.97898 21.169 7.15677 21.6558 7.3527 22.1141C7.53222 22.5353 7.72728 22.9314 8.05784 23.0695C8.73882 23.3517 9.80214 22.4187 10.5427 22.5655C11.2616 22.7079 11.8874 23.9801 12.6469 23.9801C13.4073 23.9801 14.033 22.707 14.7511 22.5655C15.4916 22.4187 16.5549 23.3526 17.2359 23.0695C17.929 22.7821 18.0196 21.3675 18.6359 20.9549C19.2564 20.5389 20.5977 20.9938 21.1241 20.4673C21.6506 19.9408 21.1958 18.5996 21.6118 17.979C22.0243 17.3628 23.4389 17.2721 23.7264 16.5791C24.0103 15.8981 23.0764 14.8339 23.2232 14.0934ZM12.6486 21.4089C11.2996 21.4089 10.0171 21.1241 8.8562 20.6114C7.50805 20.0159 6.32476 19.114 5.39521 17.9937C4.95245 17.4594 4.56751 16.876 4.24989 16.252C3.5974 14.972 3.22972 13.5229 3.22972 11.9892C3.22972 10.219 3.71995 8.56184 4.57269 7.14551C5.37018 5.82153 6.48184 4.70901 7.80582 3.91238C9.22215 3.05965 10.8793 2.56855 12.6495 2.56855C14.1823 2.56855 15.6314 2.93709 16.9123 3.58959C17.5354 3.9072 18.1197 4.293 18.654 4.73491C19.7743 5.66445 20.6771 6.84775 21.2717 8.19589C21.7853 9.35675 22.0692 10.6402 22.0692 11.9883C22.0684 17.1841 17.8427 21.4089 12.6486 21.4089Z"
                              fill="#FFAA01"
                            />
                            <path
                              d="M12.6486 20.589C17.3981 20.589 21.2484 16.7388 21.2484 11.9892C21.2484 7.23967 17.3981 3.3894 12.6486 3.3894C7.89904 3.3894 4.04877 7.23967 4.04877 11.9892C4.04877 16.7388 7.89904 20.589 12.6486 20.589Z"
                              fill="#FFAA01"
                            />
                            <path
                              d="M22.4386 12.3595C22.4386 9.6684 21.3045 7.23794 19.4886 5.51953C21.087 7.2086 22.0684 9.48629 22.0684 11.9892C22.0684 17.1833 17.8427 21.409 12.6486 21.409C10.1457 21.409 7.8671 20.4277 6.17889 18.8292C7.8973 20.6443 10.3278 21.7793 13.0189 21.7793C18.2129 21.7793 22.4386 17.5536 22.4386 12.3595Z"
                              fill="#FA9401"
                            />
                            <path
                              d="M4.41902 12.4329C4.41902 7.68327 8.26926 3.83303 13.0188 3.83303C15.5727 3.83303 17.8659 4.94642 19.4411 6.71402C17.8677 4.69094 15.4105 3.3894 12.6494 3.3894C7.89986 3.3894 4.04962 7.23964 4.04962 11.9892C4.04962 14.1849 4.87301 16.1882 6.22719 17.7072C5.09396 16.2512 4.41902 14.4214 4.41902 12.4329Z"
                              fill="#FA9401"
                            />
                            <path
                              d="M17.7667 11.1371L14.6673 10.5847C14.5741 10.5683 14.4947 10.5079 14.4533 10.4225L13.1129 7.64333C13.0059 7.42065 12.6883 7.42065 12.5813 7.64333L11.2409 10.4225C11.1994 10.5079 11.12 10.5683 11.0268 10.5847L7.92748 11.1371C7.68409 11.1803 7.59864 11.4867 7.78507 11.6498L10.1076 13.6841C10.1862 13.7531 10.2224 13.8593 10.2026 13.962L9.65193 16.8102C9.60532 17.0527 9.85907 17.2426 10.0783 17.1278L12.7116 15.7538C12.797 15.7089 12.8989 15.7089 12.9843 15.7538L15.6176 17.1278C15.8368 17.2417 16.0906 17.0527 16.044 16.8102L15.4933 13.962C15.4735 13.8593 15.5097 13.7531 15.5883 13.6841L17.9108 11.6498C18.0955 11.4867 18.011 11.1811 17.7667 11.1371Z"
                              fill="#FA9401"
                            />
                            <path
                              d="M17.5682 10.8068L14.4689 10.2544C14.3756 10.238 14.2962 10.1776 14.2548 10.0922L12.9144 7.313C12.8074 7.09033 12.4898 7.09033 12.3828 7.313L11.0424 10.0922C11.001 10.1776 10.9216 10.238 10.8283 10.2544L7.72899 10.8068C7.4856 10.8499 7.40016 11.1563 7.58658 11.3195L9.90916 13.3538C9.9877 13.4228 10.0239 13.529 10.0041 13.6317L9.45345 16.4799C9.40684 16.7224 9.66059 16.9123 9.87981 16.7975L12.5131 15.4235C12.5985 15.3786 12.7004 15.3786 12.7858 15.4235L15.4191 16.7975C15.6383 16.9114 15.8921 16.7224 15.8455 16.4799L15.2948 13.6317C15.275 13.529 15.3112 13.4228 15.3898 13.3538L17.7123 11.3195C17.897 11.1563 17.8125 10.8499 17.5682 10.8068Z"
                              fill="#F9D511"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="swiper-button-prev text-white bg-[#173CBA] rounded-full w-10 h-10 flex items-center justify-center shadow-md absolute left-0 top-1/2 transform -translate-y-1/2">
              &#8249;
            </div>
            <div className="swiper-button-next text-white bg-[#173CBA] rounded-full w-10 h-10 flex items-center justify-center shadow-md absolute right-0 top-1/2 transform -translate-y-1/2">
              &#8250;
            </div>
            <div className="container relative flex justify-center mx-auto swiper-buttons py-7 ">
              {prevButton}
              {progressBarElement}
              {nextButton}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default SimilarMentors;
const LeftArrow = () => {
  return (
    <div className="p-4 border border-black hover:border-[#173CBA] rounded-full bg-white hover:bg-[#173CBA] group">
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="text-black fill-current group-hover:text-white"
          d="M13.7917 5.45842H3.375L6.80208 2.03134C6.89972 1.9345 6.97721 1.8193 7.0301 1.69236C7.08298 1.56542 7.11021 1.42927 7.11021 1.29176C7.11021 1.15425 7.08298 1.01809 7.0301 0.891158C6.97721 0.764222 6.89972 0.649012 6.80208 0.552176C6.60691 0.358165 6.3429 0.249268 6.06771 0.249268C5.79252 0.249268 5.5285 0.358165 5.33333 0.552176L0.864584 5.03134C0.473346 5.42024 0.252326 5.94844 0.25 6.50008V6.50008C0.255069 7.04811 0.47588 7.57207 0.864584 7.95842L5.33333 12.4376C5.43046 12.534 5.54562 12.6104 5.67226 12.6623C5.7989 12.7142 5.93452 12.7407 6.07139 12.7402C6.20826 12.7398 6.3437 12.7123 6.46996 12.6595C6.59623 12.6067 6.71085 12.5295 6.80729 12.4324C6.90373 12.3352 6.9801 12.2201 7.03203 12.0934C7.08396 11.9668 7.11044 11.8312 7.10995 11.6943C7.10947 11.5574 7.08203 11.422 7.02921 11.2957C6.97638 11.1695 6.89921 11.0549 6.80208 10.9584L3.375 7.54175H13.7917C14.0679 7.54175 14.3329 7.432 14.5282 7.23665C14.7236 7.0413 14.8333 6.77635 14.8333 6.50008C14.8333 6.22382 14.7236 5.95887 14.5282 5.76352C14.3329 5.56817 14.0679 5.45842 13.7917 5.45842Z"
        />
      </svg>
    </div>
  );
};

const RightArrow = ({ isPrevHovered }: { isPrevHovered: boolean }) => {
  return (
    <div
      className={`p-4 border rounded-full ${
        isPrevHovered ? "bg-white border-black" : "bg-blue border-blue"
      }`}
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={`${
            isPrevHovered
              ? "fill-current text-black"
              : "fill-current text-white"
          }`}
          d="M1.20833 5.45842H11.625L8.19792 2.03134C8.10028 1.9345 8.02279 1.8193 7.9699 1.69236C7.91702 1.56542 7.88979 1.42927 7.88979 1.29176C7.88979 1.15425 7.91702 1.01809 7.9699 0.891158C8.02279 0.764222 8.10028 0.649012 8.19792 0.552176C8.39309 0.358165 8.6571 0.249268 8.93229 0.249268C9.20748 0.249268 9.4715 0.358165 9.66667 0.552176L14.1354 5.03134C14.5267 5.42024 14.7477 5.94844 14.75 6.50008V6.50008C14.7449 7.04811 14.5241 7.57207 14.1354 7.95842L9.66667 12.4376C9.56954 12.534 9.45438 12.6104 9.32774 12.6623C9.2011 12.7142 9.06548 12.7407 8.92861 12.7402C8.79174 12.7398 8.6563 12.7123 8.53004 12.6595C8.40377 12.6067 8.28915 12.5295 8.19271 12.4324C8.09627 12.3352 8.0199 12.2201 7.96797 12.0934C7.91604 11.9668 7.88956 11.8312 7.89005 11.6943C7.89053 11.5574 7.91797 11.422 7.97079 11.2957C8.02362 11.1695 8.10079 11.0549 8.19792 10.9584L11.625 7.54175H1.20833C0.932065 7.54175 0.667112 7.432 0.471762 7.23665C0.276411 7.0413 0.166666 6.77635 0.166666 6.50008C0.166666 6.22382 0.276411 5.95887 0.471762 5.76352C0.667112 5.56817 0.932065 5.45842 1.20833 5.45842Z"
        />
      </svg>
    </div>
  );
};
